import { queryOptions, useQuery } from '@tanstack/react-query';
import { DashboardApi } from '@/lib/api/loop-visualization/dashboard';
import { loopVisualizationQueryKeys } from '@/lib/query-keys/loop-visualizations';

export const getDashboardsQueryOptions = (loopId: number) =>
  queryOptions({
    queryKey: loopVisualizationQueryKeys.dashboard.list(loopId),
    queryFn: () => DashboardApi.fetchDashboards(loopId),
    enabled: !!loopId,
  });

export const getDashboardQueryOptions = (dashboardId: number) =>
  queryOptions({
    queryKey: loopVisualizationQueryKeys.dashboard.detail(dashboardId),
    queryFn: () => DashboardApi.fetchDashboard(dashboardId),
    enabled: !!dashboardId,
  });

export const useDashboards = (loopId: number) => useQuery(getDashboardsQueryOptions(loopId));

export const useDashboard = (dashboardId: number) =>
  useQuery(getDashboardQueryOptions(dashboardId));
